"use client"
import React, { useState, useRef, useContext, LayoutContext } from 'react';
import { Chip } from 'primereact/chip';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import BlockViewer from '../BlockViewer';

//import Link from 'next/link';

import { StyleClass } from 'primereact/styleclass';
import { Button } from 'primereact/button';
import { Ripple } from 'primereact/ripple';
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';
import { Panel } from 'primereact/panel';
import { Dialog } from 'primereact/dialog';
import { Avatar } from 'primereact/avatar';
import { ScrollPanel } from 'primereact/scrollpanel';
import { DeferredContent } from 'primereact/deferredcontent';
import { OverlayPanel } from 'primereact/overlaypanel';

//import { LayoutContext } from '../../../layout/context/layoutcontext';
//import { NodeRef } from '@/types';
import { classNames } from 'primereact/utils';
import FormularioCalculadoraCredito from '../components/DataTableGenerica/FormularioCalculadoraCredito';


import AuthStorage from '../storage/AuthStorage';
import AuthController from '../controller/AuthController';

import { GenericaSistemaService } from '../service/GenericaSistemaService';

import "../assets/css/BlocksGuestLandingPageCredito.css";
import Formulario from './DataTableGenerica/Formulario';

const BlocksGuestLandingRestablecimientoClave = (props) => {
    const [isHidden, setIsHidden] = useState(false);
    //const { layoutConfig } = useContext(LayoutContext);
    const menuRef = useRef(null);

    const btInicioSesion = useRef(null);
    const op = useRef(null);

    const labelErrorRef = useRef(null);
    const [textoError, setTextoError] = useState("");

    const [intentoErrado, setIntentoErrado] = useState(0);
    const [vecesBotonPresionado, setVecesBotonPresionado] = useState(0);

    const modExternal = "CREDITO";

    const authController = new AuthController();
    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();

    const genericaSistemaService = new GenericaSistemaService();

    let dataConfigSubdomain = authStorage.getConfigSubdomain();

    let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit, urlLogoLogin } = dataConfigSubdomain;

    const { userName, idEmpresa, idioma } = userDetails;

    // Para autorregistro
    let emptyGenericaSistemaInitAutorregistro = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO", uts: { "ambito": "CREDITO" }
    };

    let selectedTipoGenericaFormularioAutoregistro = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO"
    };

    let selectedTipoGenericaFormularioAutoregistroConfirmacionOpt = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO_CONFIRMACION_OPT"
    };

    // Para restablecimiento 

    let emptyGenericaSistemaInitRestablecimiento = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_RESTABLECIMIENTO_CLAVE", uts: { "ambito": "CREDITO" }
    };

    let selectedTipoGenericaFormularioRestablecimiento = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_RESTABLECIMIENTO_CLAVE"
    };

    let selectedTipoGenericaFormularioRestablecimientoConfirmacionOpt = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO_CONFIRMACION_OPT"
    };


    const etiquetasModulo = [{ "etiqueta": "DIALOG_HEADER_TEXT", "ctiTexto": "hola" }];


   

    const formFacturaRef = useRef(null);


    const [selectedTipoGenericaFormularioFactura, setSelectedTipoGenericaFormularioFactura] = useState(undefined);
    const [metadataGenericaFormularioFactura, setMetadataGenericaFormularioFactura] = useState([]);
    const [genericaFormularioFactura, setGenericaFormularioFactura] = useState(emptyGenericaSistemaInit);
    const [genericaSistemaDialogFormularioFactura, setGenericaSistemaDialogFormularioFactura] = useState(false);
    const [genericaSistemaDialogFormulario, setGenericaSistemaDialogFormulario] = useState(false);

    const [submitted, setSubmitted] = useState(false);

    const [visibleSolicitarCredito, setVisibleSolicitarCredito] = useState(false);
    const [visibleIniciarSesion, setVisibleIniciarSesion] = useState(false);
    const [clientIP, setClientIP] = useState(undefined);

    const [visibleRetablecerClave, setVisibleRetablecerClave] = useState(false);

    const [guidIntento, setGuidIntento] = useState(window.crypto.randomUUID());
    const [editando, setEditando] = useState(false);

    const [lazyParams, setLazyParams] = useState(undefined);

    const lazyParamInit = {
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            //'ctiTexto': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }
    };


    const lazyParamsInitSelected = useRef(Object.assign({}, lazyParamInit));


    const toast = useRef(null);

    const selectedTipoGenerica = useRef({
        tg: "BPM_VSTA_SOLICITUD_CD_INVITADO_REFERENCIA_ORDEN_ACADEMICA_CALCULADORA",
        cti: "",
        ctiTexto: "",
        //orden: operaciontgRef.ordentgRef,
        //cgCampo: operaciontgRef.cgCampotgRef,
        operaciones: undefined,
        version: window.crypto.randomUUID(),
        tipoOrganizacionContenido: "TABLA",
        filtroUts: { "solicitud": 0 },
        ctiTextoFiltroUts: ""
    });

    const toggleMenuItemClick = () => {
        setIsHidden((prevState) => !prevState);
    };

    //                        <Link href="/" className="flex align-items-center">
    //                        <img src={`/layout/images/${layoutConfig.colorScheme === 'light' ? 'logo-dark' : 'logo-white'}.svg`} alt="Sakai Logo" height="50" className="mr-0 lg:mr-2" />
    //                       <span className="text-900 font-medium text-2xl line-height-3 mr-8">SAKAI</span>
    //                  </Link>


    const hideDialog = () => {
        setSubmitted(false);
        setGenericaSistemaDialogFormularioFactura(false);
        setGenericaSistemaDialogFormulario(false);
    }

    const clickSolicitarCredito = async (e) => {
        setIndiceDialog(0);
        setVisibleSolicitarCredito(true);
    }

    const clickIniciarSesion = async (e) => {

        setIndiceDialog(0);
        setVisibleIniciarSesion(true);
        setVisibleSolicitarCredito(false);
        setVisibleRetablecerClave(false);

        console.log("clickIniciarSesion, ");
        if (clientIP === undefined) {

            await authController.getClientIP().then(response => {

                setClientIP(response);
                op.current.toggle(e);

            });

        }
        else {
            op.current.toggle(e);
        }
    }

    const clickIniciarRegistro = async (e) => {
        //const onEditarFormularioFactura = async (e) => {

        //setEditando(true);

        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);

        //let tgRefOps = selectedTipoGenerica.operacionesCampos.find(x => x.seccion === "FORMULARIO_CALIFICACION_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_CREAR_INTENTO")


        //setSelectedTipoGenerica(newSelectedTipoGenerica);

        let newGenericaSistema = {
            id: -1, idEmpresa: idEmpresa, idioma: idioma,
            tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO", uts: {}
        }
        newGenericaSistema.uts['solicitud'] = 0;
        newGenericaSistema.uts['guidIntento'] = newGuid;

        /*
        for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
            itemOpsCampo = newSelectedTipoGenerica.operacionesCampos[i];
            if (itemOpsCampo.id === tgRefOps.id) {
                genericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotg];
            }

        }*/

        var tg = "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO";



        /*

    
    
    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

    console.log("sende, ", genericaSistema);

    let dialog = genericaSistemaDialogRef.current;

    */



    }

 

    const onSaveSuccessfulFormulario = (_genericaSistema, idOriginal, genericasSistemaAffect) => {

        hideDialog();

        console.log();

    }

    const onClickContentDialog = async (index) => {

        console.log("setIndiceDialog_index, ", index);

        if (index === 4) {  //Para registro

            let tg = "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO";

            await genericaSistemaService.getMetadataGenericasSistema(tg, idEmpresa, idioma, userName).then(data => {

                let newGenerica = { ...emptyGenericaSistemaInitAutorregistro };
                setGenericaFormularioFactura(newGenerica);
                setMetadataGenericaFormularioFactura(data);
                setIndiceDialog(index);
                setGenericaSistemaDialogFormulario(true);
                setVisibleSolicitarCredito(true);
            });

            //setIndiceDialog(index);

        }
        else if (index === 5) {  //Para Restablecimiento

            let tg = "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO";

            await genericaSistemaService.getMetadataGenericasSistema(tg, idEmpresa, idioma, userName).then(data => {

                let newGenerica = { ...emptyGenericaSistemaInitRestablecimiento };
                setGenericaFormularioFactura(newGenerica);
                setMetadataGenericaFormularioFactura(data);
                setIndiceDialog(index);
                setGenericaSistemaDialogFormulario(true);
                setVisibleSolicitarCredito(false);
                setVisibleRetablecerClave(true);

            });

            //setIndiceDialog(index);

        }



        setIndiceDialog(index);

    }

    return (<>

        <div className=" align-items-centerm-1 col-12 my-auto flex flex-column text-center lg:text-left lg:align-items-center border-round-md "
            style={{ paddingTop: "0" }}>

            <div style={{ width: '90%', maxHeight: '80%', zIndex: "6" }}>

                <h2 className="line-height-1 text-4xl font-normal text-green-600" style={{ textAlign: "center" }}>Autorización para el tratamiento de datos personales</h2>

                <p className='mt-4 text-700 text-2xl line-height-3 mr-0 md:mr-2 text-justify'>
                    Autorizo expresa e irrevocablemente a Corporación Universitaria del Caribe de forma libre y voluntariamente, para que reporte, consulte y divulgue a la Asociación Bancaria y de entidades Financieras de Colombia ASOBANCARIA, Datacrédito, CIFIN o a cualquier otro operador y/o fuente de información legalmente establecido, toda la información referente a mi comportamiento como estudiante o representante del estudiante que se relaciones con el nacimiento, ejecución modificación, liquidación y/o extinción de las obligaciones que se deriven de la relación jurídica en virtud de la cual Corporación Universitaria del Caribe me dio plazo de pago para cubrir mis obligaciones pecuniarias, en cualquier tiempo, y que podrá reflejarse en las bases de datos de la CIFIN, DATACREDITO o de cualquier otro operador y/o fuente de información legalmente establecido. La permanencia de la información estará sujeta a los principios, términos y condiciones consagrados en la ley 1266 de 2008 y demás normas que lo modifiquen, aclaren o reglamenten.
                    En este sentido autorizo, expresa e irrevocablemente a Corporación Universitaria del Caribe para que consulte toda la información financiera, crediticia, comercial, de servicios y la proveniente de otros países, atinente a mis relaciones comerciales que tenga con el Sistema Financiero, comercial y de servicios, o de cualquier sector, tanto en Colombia como en el Exterior, en cualquier tiempo.
                    Adicionalmente, la presente autorización se extiende para que Corporación Universitaria del Caribe puede compartir información con terceros públicos o privados, bien sea que estos ostenten la condición de fuentes de información, operadores de información o usuarios, administradores y gestores de cobro de cartera, con quienes Corporación Universitaria del Caribe tenga vínculos jurídicos de cualquier naturaleza.
                    Quien suministre información que no corresponda a la realidad podría incurrir en el delito de falsedad en documento privado.


                </p>


                <h2 className="line-height-1 text-4xl font-normal text-green-600" style={{ textAlign: "center" }}>Registra tus datos</h2>
                <p className='mt-4 text-700 text-2xl line-height-3 mr-0 md:mr-2 text-justify'>
                    <strong>Importante:</strong> Por favor, ingresa tus datos exactamente igual a como se muestran en tu documento de identidad.
                    Recueda que únicamente debe registrarse el deudor o titular de la solicitud.
                </p>

                <Formulario className="text-4xl"  //ref={formRef} 
                    genericaSistemaDialog={genericaSistemaDialogFormulario} genericaSistema={genericaFormularioFactura}
                    metadataGenericaSistemaForm={metadataGenericaFormularioFactura}
                    etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormulario}
                    utilizaDialog={false} style={{ width: "100%" }}
                    onHideForm={hideDialog} requiereConfirmacionOPT={true} selectedTipoGenericaConfirmacionOPT={selectedTipoGenericaFormularioConfirmacionOpt}
                    onSaveSuccessful={onSaveSuccessfulFormulario}
                ></Formulario>

            </div>

            <Button style={{ width: "90%" }} className='mt-4 bg-white text-2xl text-green-600 surface-border'
                label="Regresar" severity="secondary" outlined onClick={(e) => onClickContentDialog(0)} />

        </div>
    </>
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default BlocksGuestLandingRestablecimientoClave;